import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Render private dashboard media through the authenticated Axios client. */
export default function DashboardImage({ source, alt = "", className = "" }) {
  const [url, setUrl] = useState(null);
  const isPrivate = typeof source === "string" && source.startsWith("/my/farms/");
  useEffect(() => {
    if (!isPrivate) { setUrl(null); return; }
    const controller = new AbortController();
    let objectUrl;
    setUrl(null);
    api.get(source, { responseType: "blob", signal: controller.signal })
      .then(({ data }) => {
        if (controller.signal.aborted) return;
        if (!["image/jpeg", "image/png", "image/webp"].includes(data.type)) return;
        objectUrl = URL.createObjectURL(data);
        setUrl(objectUrl);
      })
      .catch(() => { if (!controller.signal.aborted) setUrl(null); });
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [source, isPrivate]);
  const resolved = isPrivate ? url : source;
  return resolved ? <img src={resolved} alt={alt} className={className} /> : null;
}
